import React, { useState } from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { ReorderModal } from "../../../../boxes/ReorderModal/ReorderModal";
import { useMemberships } from "./hooks/useMemberships";
import { useSaveOrder } from "./hooks/useSaveOrder";

export function ObOrder() {
  const { tCommon } = useAppTranslation.Common();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { memberships, isMembershipsLoading } = useMemberships();
  const { save, isSaving } = useSaveOrder({
    onSuccess: () => {
      setIsModalOpen(false);
    }
  });

  return (
    <>
      <button
        className="easy-link no-padding m-l-10"
        onClick={() => setIsModalOpen(true)}
      >
        {tCommon("label.obOrder")}
      </button>
      {isModalOpen && (
        <ReorderModal
          isLoading={isMembershipsLoading}
          isSaving={isSaving}
          isOpen={isModalOpen}
          data={memberships}
          onClose={() => setIsModalOpen(false)}
          title={tCommon("label.obOrder")}
          onSave={save}
        />
      )}
    </>
  );
}